/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Wizard_Sreality_NoteInputs */

const cs_portals_wizard_sreality_note = /** @type {(inputs: Portals_Wizard_Sreality_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality není veřejné přihlášení. Kancelář potřebuje smluvený importní klíč.`)
};

const en_portals_wizard_sreality_note = /** @type {(inputs: Portals_Wizard_Sreality_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality is not a public signup. The office needs its contracted import key.`)
};

/**
* | output |
* | --- |
* | "Sreality is not a public signup. The office needs its contracted import key." |
*
* @param {Portals_Wizard_Sreality_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_wizard_sreality_note = /** @type {((inputs?: Portals_Wizard_Sreality_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Wizard_Sreality_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_wizard_sreality_note(inputs)
	return cs_portals_wizard_sreality_note(inputs)
});